import { LoaderOverlay, Scrim } from '@deque/cauldron-react';
import React from 'react';

interface ScrimmedLoaderProps
  extends React.ComponentPropsWithRef<typeof LoaderOverlay> {
  loaderRef?: React.Ref<HTMLDivElement>;
}

const ScrimmedLoader = ({
  label,
  loaderRef,
  children,
  focusTrap,
  'aria-label': ariaLabel,
  ...props
}: ScrimmedLoaderProps): React.ReactElement => {
  return (
    <>
      <Scrim show={true} />
      <LoaderOverlay
        tabIndex={-1}
        ref={loaderRef}
        label={label}
        aria-label={ariaLabel ?? label}
        focusTrap={focusTrap}
        focusOnInitialRender
        data-testid="loaderOverlay"
        {...props}
      >
        {children}
      </LoaderOverlay>
    </>
  );
};

export default ScrimmedLoader;
